//imports****************************************************************
import { Box } from "@mui/system";
import { useEffect } from "react";
import Header from "../../common/header/Header";
import Breadcrumb from "../../common/header/Breadcrumb";
import AgentListView from "../../components/agentListView/AgentListView";

// render function*******************************************************
function Agents() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //return function******************************************************
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className="page-background">
        <Header />
        <Breadcrumb />
        <AgentListView />
      </Box>
    </>
  );
}

export default Agents;
